import styled from "styled-components";

export const SSettingsTopNavBody = styled.div`
  display: flex;
  flex-direction: column;
  height: 32px;
  justify-content: center;
`;
